import { create } from "zustand";

export const useLoaderStore = create((set) => ({
    loading: false,
    setLoading: (state) => set({ loading: state }),
}));
